// MIRRORS `position` in the admin's OmpSectionCatalog. Body sections get the
// `+` buttons and drag grip; Top and Bottom get the outline only.
import { PreviewZone, SectionKey } from '@/constants'

export const SECTION_ZONES: Record<SectionKey, PreviewZone> = {
  [SectionKey.Header]: PreviewZone.Top,
  [SectionKey.AnnouncementBar]: PreviewZone.Top,
  [SectionKey.WelcomeMessage]: PreviewZone.Top,
  [SectionKey.NavigationalBlocks]: PreviewZone.Top,
  [SectionKey.SubscriptionList]: PreviewZone.Top,
  [SectionKey.OrderList]: PreviewZone.Top,
  [SectionKey.Footer]: PreviewZone.Bottom,
  [SectionKey.NextOrderDetails]: PreviewZone.Body,
  [SectionKey.OrderSummary]: PreviewZone.Body,
  [SectionKey.CrossSellCarousel]: PreviewZone.Body,
  [SectionKey.ImageBanner]: PreviewZone.Body,
  [SectionKey.FaqSection]: PreviewZone.Body,
  [SectionKey.TextBox]: PreviewZone.Body,
  [SectionKey.ShippingAndPayment]: PreviewZone.Body,
  [SectionKey.Instagram]: PreviewZone.Body,
  [SectionKey.TextAndImage]: PreviewZone.Body,
  [SectionKey.Callout]: PreviewZone.Body,
  [SectionKey.Video]: PreviewZone.Body,
  [SectionKey.Columns]: PreviewZone.Body,
}

export function zoneFor(key: SectionKey): PreviewZone {
  return SECTION_ZONES[key] ?? PreviewZone.Body
}
